// AppliancesSection.jsx
import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const ApplianceSummary = ({ appliances }) => {
  if (!appliances || appliances.length === 0) {
    return <p className="text-gray-500">No appliances selected</p>
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {appliances.map((appliance, index) => (
        <Card key={index} className="p-4">
          <h3 className="font-semibold mb-2">{appliance.name}</h3>
          {appliance.dimensions && (
            <div className="text-sm text-gray-600">
              <p>Width: {appliance.dimensions.width}"</p>
              <p>Depth: {appliance.dimensions.depth}"</p>
              <p>Height: {appliance.dimensions.height}"</p>
              {appliance.productId && (
                <p className="mt-1">Product #: {appliance.productId}</p>
              )}
              {appliance.additionalInfo && (
                <p className="mt-1 italic">{appliance.additionalInfo}</p>
              )}
            </div>
          )}
        </Card>
      ))}
    </div>
  )
};

export const AppliancesSection = ({ projectData, onEdit, isEditable }) => (
  <Card className="mb-4">
    <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
      <CardTitle className="text-xl font-bold">Appliances</CardTitle>
      {isEditable && (
        <Button variant="outline" size="sm" onClick={() => onEdit("appliances")}>
          Edit
        </Button>
      )}
    </CardHeader>
    <CardContent>
      <ApplianceSummary appliances={projectData?.appliances} />
    </CardContent>
  </Card>
);